// FreeInitiative.jsx
import React, { useState } from "react";
import {
    BookOpen,
    Edit3,
    Users,
    UserCheck,
    ClipboardCheck,
    Clock,
    Zap,
    Play,
    CheckSquare,
    Calendar,
} from "lucide-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import "./FreeInitiative.css";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import LiveChat from "../section-component/live-chat/LiveChat";
import DailyMains from "./daily-mains/DailyMains";
import PracticePYQ from "./practice-pyq/PracticePYQ";
import PersonalMentorship from "./personal-mentorship/PersonalMentorship";
import InterviewGuidance from "./interview-guidance/InterviewGuidance";
import CurrentAffairs from "./current-affairs/CurrentAffairs";
import CAQuiz from "./ca-quiz/CAQuiz";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const FreeInitiative = () => {
    return (
        <>
            

            <DailyMains />
            {/* <PracticePYQ /> */}
            <PersonalMentorship />
            <InterviewGuidance />
            {/* <CurrentAffairs /> */}
            <CAQuiz />

            
        </>
    );
};

export default FreeInitiative;
